<button
  class="trigger blank-button"
  [class.mobile]="isMobile"
  (click)="onTriggerClick()"
  merriNoFocusLink
  matRipple
>
  <span class="trigger-content">
    <ng-container *ngIf="!isMobile; else mobile">
      <mat-icon
        class="trigger-icon"
        svgIcon="chevron_down"
        [class.open]="isOpen()"
      ></mat-icon>
      <span class="trigger-text">{{ triggerText }}</span>
    </ng-container>
  </span>
</button>

<ng-template #mobile>
  <mat-icon
    class="trigger-icon-mobile"
    svgIcon="question_mark"
  ></mat-icon>
</ng-template>
